import type { PreviewFile } from '../AppAction';

import { _sendReply, _fakeMessage } from '../Communication';
import { openFile } from '../DebugActions';
import { writeFile } from '../Filesystem/Helper';
import { registerHandler } from '../MessageManager';

import { debugArAppActionHandler } from './ArAppAction';

import { messageManager } from '@egr/xbox/messagebar/MessageManager';
import { sendMailInBrowser } from '@egr/xbox/share-by-mail/MailUtils';
import { getContent, downloadUrl } from '@egr/xbox/utils/Download';
import { Logger } from '@egr/xbox/utils/errors/Logger';

import { isNotNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

export function registerDebugAppAction(cancelMap: Map<number, string>): void {
    let bgSyncHandler: VoidFunction | undefined;
    document.addEventListener('visibilitychange', (): void => {
        if (document.visibilityState === 'visible') {
            _fakeMessage({
                transaction_id: -1,
                type: 'webaction',
                action: 'synchronize',
                arguments: 'foreground',
            });
        } else if (bgSyncHandler != null) {
            try {
                bgSyncHandler();
            } finally {
                bgSyncHandler = undefined;
            }
        }
    });

    registerHandler({
        type: 'appaction',
        callback: (event: MessageEvent): void => {
            switch (event.data.action) {
                case 'background_content_synchronization':
                    if (
                        isNotNullOrEmpty(event.data.arguments.url) &&
                        isNotNullOrEmpty(event.data.arguments.path)
                    ) {
                        bgSyncHandler = async (): Promise<void> => {
                            try {
                                const content: ArrayBuffer = await getContent(event.data.arguments.url);
                                await writeFile(event.data.arguments.path, content);
                            } catch (error) {
                                Logger.error(error);
                            }
                        };

                        _sendReply(event.data.transaction_id, false, undefined);
                    } else {
                        bgSyncHandler = undefined;
                        _sendReply(event.data.transaction_id, true, 'Invalid path');
                    }
                    break;
                case 'import':
                    void openFile(event.data.arguments);
                    break;
                case 'preview':
                    const file: PreviewFile = (event.data.arguments as PreviewFile);
                    downloadUrl(file.url, file.title);
                    _sendReply(event.data.transaction_id, false, undefined);
                    break;
                case 'cancel_download':
                    cancelMap.set(event.data.arguments.request_id, event.data.arguments.error_message);
                    break;
                case 'compose_mail':
                    void sendMailInBrowser(event.data.arguments.body, event.data.arguments.recipients, event.data.arguments.subject);
                    break;
                case 'ar':
                    debugArAppActionHandler(event.data);
                    break;
                case 'openBrowser':
                case 'SFSafariViewController':
                    window.open(event.data.arguments, '_blank');
                    break;
                case 'get_cookie_state':
                    _sendReply(event.data.transaction_id, false, {
                        hide: false,
                        youtube: true,
                        telemetry: true,
                        diagnostics: true
                    });
                    break;
                case 'send_toast_message':
                    messageManager.showMessage(event.data.arguments);
                    break;
                default:
                    if (event.data.transaction_id !== -1) {
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        _sendReply(event.data.transaction_id, true, `Unsupported app action: ${event.data.action}`);
                    } else {
                        Logger.warn('Unsupported app action:', event.data.action);
                    }
                    break;
            }
        }
    });
}
